import { useEffect, useState } from "react";
import { dds } from "./ddsClient";

export function useDDSGetData(preset, options = {}) {
  const { enabled = true } = options;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !preset) return;

    let active = true;

    setLoading(true);

    dds
      .getStaticData(preset)
      .then((res) => {
        if (active) setData(res);
      })
      .catch((err) => {
        if (active) setError(err);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [JSON.stringify(preset), enabled]);

  return { data, loading, error };
}

